var _excluded = ["className", "children"],
    _excluded2 = ["className", "children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { tint, shade } from 'polished';

var UPlogo = function UPlogo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M26.9 26.9h-4.2L20 16.7l-5.9 10.2H9.4l9.1-15.7L17 5.7 4.8 26.9H.1L15.6 0h4.1l1.8 6.7h4.3l-2.9 5 4 15.2z",
    fill: "#3f3d4b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32 27.1l-8-8v6H0v4h24v6z",
    fill: "#28C081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.7l-5.9 10.2H9.4l9.1-15.7L17 5.7 4.8 26.9H.1L15.6 0h4.1l1.8 6.7h4.3l-2.9 5",
    fill: "#3f3d4b"
  }));
};

UPlogo.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 34 34",
  xmlns: "http://www.w3.org/2000/svg"
};
import Button, { StyledButton } from '../Button/BaseButton';
import Pipeline from '../Pipeline';
var brandColors = {
  baseColor: '#5c50ca',
  hoverColor: tint(0.1, '#5c50ca'),
  activeColor: shade(0.1, '#5c50ca'),
  foregroundColor: '#FFFFFF'
};
var UPStyledButton = /*#__PURE__*/styled(StyledButton).withConfig({
  displayName: "AlgoSendButton__UPStyledButton",
  componentId: "sc-wuexk7-0"
})(["&{transition:all 0.15s ease;}&:hover{box-shadow:0px 2px 4px rgba(0,0,0,0.2);}&& > svg.r-up-icon{height:", ";width:", ";margin-right:0.5rem;}"], function (props) {
  return props.size === 'small' ? '16px' : '24px';
}, function (props) {
  return props.size === 'small' ? '16px' : '24px';
});
var StyledButtonSolid = /*#__PURE__*/styled(UPStyledButton).withConfig({
  displayName: "AlgoSendButton__StyledButtonSolid",
  componentId: "sc-wuexk7-1"
})(["&{color:", ";background:", ";}&:hover{background-color:", ";}&:active{background-color:", ";}> svg:first-child{fill:", ";}"], brandColors.foregroundColor, brandColors.baseColor, brandColors.hoverColor, brandColors.activeColor, brandColors.foregroundColor);
var StyledButtonOutline = /*#__PURE__*/styled(UPStyledButton).withConfig({
  displayName: "AlgoSendButton__StyledButtonOutline",
  componentId: "sc-wuexk7-2"
})(["&{color:#333;background:", ";border:1px solid #ccc;}&:hover{background-color:#f3f2f2;}&:active{background-color:#e4e4e4;}"], brandColors.foregroundColor);

var ButtonBody = function ButtonBody(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UPlogo, {
    className: 'algosend-icon',
    size: size
  }), children);
};

var AlgoSendButtonBSolid = function AlgoSendButtonBSolid(_ref2) {
  var className = _ref2.className,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(StyledButtonSolid, _extends({
    className: 'algosend-solid'
  }, props), /*#__PURE__*/React.createElement(ButtonBody, {
    children: children,
    size: props.size
  }));
};

var AlgoSendButtonBOutline = function AlgoSendButtonBOutline(_ref3) {
  var className = _ref3.className,
      children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded2);

  return /*#__PURE__*/React.createElement(StyledButtonOutline, _extends({
    className: 'algosend-outline'
  }, props), /*#__PURE__*/React.createElement(ButtonBody, {
    children: children,
    size: props.size
  }));
};

var defaultProps = _objectSpread(_objectSpread({}, Button.defaultProps), {}, {
  width: [1, 'auto'],
  borderRadius: 1,
  boxShadow: 1
});

AlgoSendButtonBSolid.defaultProps = defaultProps;
AlgoSendButtonBOutline.defaultProps = defaultProps;
var AlgoSendButtonB;
AlgoSendButtonB = AlgoSendButtonBOutline;
AlgoSendButtonB.Solid = AlgoSendButtonBSolid;
AlgoSendButtonB.Outline = AlgoSendButtonBOutline;
AlgoSendButtonB.propTypes = _objectSpread({}, Button.propTypes);
AlgoSendButtonB.displayName = 'AlgoSendButtonB';

var AlgoSendButton = function AlgoSendButton(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AlgoSendButtonB, {
    className: "AlgoSendButton",
    onClick: function onClick() {
      Pipeline.send(props.recipient, parseInt(props.amount || 1), props.note || '', Pipeline.myAddress, props.wallet, props.index || 0).then(function (data) {
        if (typeof data !== 'undefined') {
          if (props.returnTo !== undefined) {
            var object = {};
            object[props.returnTo] = data;
            props.context.setState(object);
          }

          if (typeof props.onChange === 'function') {
            props.onChange(data);
          }
        }
      });
    }
  }, "Send"));
};

export default AlgoSendButton;